// extracted by mini-css-extract-plugin
export default {"wrapper":"Switch_wrapper__OdHV7","active":"Switch_active__sBJDB","disabled":"Switch_disabled__5KXMJ","content":"Switch_content__UsZkU"};